import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import './Home.css';
import { FaUser, FaCog, FaCalendarAlt, FaGlobe, FaFileAlt, FaHome, FaSignOutAlt } from 'react-icons/fa';
import { HiDocumentReport } from "react-icons/hi";

import { Outlet } from 'react-router-dom';
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg'
import { getServicesByRoleId, logoutService } from "../../../services/loginService";
import { capitalizeFirstLetter } from '../../../utils/validations';
const Home = ({ logout }) => {
  const [assignedServices, setAssignedServices] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null); // For error feedback
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const employeeUniqueId = searchParams.get('employeeUniqueId');
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const username = localStorage.getItem('username');
  const full_name = localStorage.getItem('full_name');
  const roleId = localStorage.getItem("roleId");
  const token = localStorage.getItem("token");
  // Fetch services based on roleId
  useEffect(() => {
    if (!roleId) {
      console.log("No roleId found, skipping API call");
      setError("No role ID available. Please log in again.");
      return;
    }

    const fetchServices = async () => {
      try {
        console.log("Fetching services for roleId:", roleId);
        const data = await getServicesByRoleId(roleId);
        console.log("API Response:", data);

        // filter assigned services
        const filterServices = (services) => {
          return services
            .map((s) => {
              const children = filterServices(s.childServices || []);
              if (s.assigned || children.length > 0) {
                return { ...s, childServices: children };
              }
              return null;
            })
            .filter(Boolean);
        };

        const filteredServices = filterServices(data);
        console.log("Filtered Services:", filteredServices);

        setAssignedServices(filteredServices);
        setError(null);
      } catch (err) {
        console.error("Error fetching services:", err);
        setAssignedServices([]);
        setError("Failed to load services. Please try again.");
      }
    };

    fetchServices();
  }, [roleId]);

  const getIcon = (serviceName) => {
    if (!serviceName) return FaFileAlt;

    const normalized = serviceName.replace(/\s+/g, '').toLowerCase();

    const icons = {
      usermanagement: FaUser,
      admin: FaUser,
      leavemanagement: FaCalendarAlt,
      attendance: FaCalendarAlt,
      employee: FaGlobe,
      monthlyactivities: FaCalendarAlt,
      reports: HiDocumentReport,
    };

    return icons[normalized] || FaFileAlt;
  };
  // // Close sidebar automatically whenever the route changes
  // useEffect(() => {
  //   setIsSidebarOpen(false);
  //   setActiveDropdown(null);
  // }, [location.pathname]);
  useEffect(() => {
    console.log("🔁 Route changed:", location.pathname, location.key);
    setIsSidebarOpen(false);
    setActiveDropdown(null);
  }, [location.pathname, location.key]);


  const renderServiceLinks = useCallback(
    (services, isChild = false) => {
      return services.map((service) => {
        const hasChildren = service.childServices && service.childServices.length > 0;
        const isActive = activeDropdown === service.serviceId;
        const hasAssignedChildren =
          hasChildren && service.childServices.some((child) => child.assigned || child.childServices?.length > 0);
        if (!service.assigned && !hasAssignedChildren) return null;

        const formatServiceName = (name) => name.replace(/([a-z])([A-Z])/g, "$1 $2");

        // Only parent services get icons
        const Icon = !isChild ? getIcon(service.serviceName) : null;

        if (hasChildren) {
          return (
            <div
              key={service.serviceId}
              className="sidebar-link"
              onMouseEnter={() => setActiveDropdown(service.serviceId)}
              onMouseLeave={() => setActiveDropdown(null)}
              onClick={(e) => {
                e.stopPropagation(); // prevent unwanted bubbling
                setActiveDropdown(activeDropdown === service.serviceId ? null : service.serviceId);
              }}

            >
              <div className="dropdown-header">
                {Icon && <Icon className="icon" />} {formatServiceName(service.serviceName)}
                <span className="arrow">{isActive ? " ▲" : " ▼"}</span>
              </div>
              {isActive && <div className="dropdown-items">{renderServiceLinks(service.childServices, true)}</div>}
            </div>
          );
        }

        return (
          <div key={service.serviceId} className="sidebar-link">
            <Link
              to={service.serviceLink}
              onClick={handleChildClick}   // 👈 close only on child click
            >
              {Icon && <Icon className="icon" />} {formatServiceName(service.serviceName)}
            </Link>

          </div>
        );
      });
    },
    [activeDropdown]
  );

  const handleLogin = () => navigate('/login');

  const handleLogout = async () => {
    try {
      const employeeId = localStorage.getItem('employeeId');
      if (!employeeId) {
        console.error("No employeeId found in localStorage");
        setError("No employee ID found. Please log in again.");
        return;
      }

      const result = await logoutService(employeeId);

      if (result.success) {

        window.location.href = '/login';
      }



      // Clear localStorage
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('employeeId');
      localStorage.removeItem('role');
      localStorage.removeItem('email');
      localStorage.removeItem('full_name');
      localStorage.removeItem('user');
      localStorage.removeItem('roleId');
      localStorage.removeItem('token');

      // Call logout prop and navigate to login
      logout();
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout API error:", err);
      setError("Failed to logout. Please try again.");
    }
  };

  const handleChildClick = () => {
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);     // close sidebar
      setActiveDropdown(null);     // collapse parent
    }
  };


  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="home-container">
      <div className={`part-1 ${isSidebarOpen ? "sidebar-open" : ""}`}>
        {isLoggedIn && (
          <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
            <div className="sidebar-top">
              <div className="sidebar-link">
                <Link to="/home" onClick={handleChildClick}>
                  <FaHome className="icon" /> Home
                </Link>
              </div>
              {error && <div className="error-message">{error}</div>}
              {renderServiceLinks(assignedServices)}
              <div className="sidebar-link">
                <Link to="/login" onClick={handleLogout}>
                  <FaSignOutAlt className="icon" /> Logout
                </Link>
              </div>
            </div>
          </div>
        )}

        <nav className="navbar">
          <div className="navbar-items-style">
            {isLoggedIn && (
              <div className="hamburger-menu" onClick={toggleSidebar}>
                &#9776;
              </div>
            )}
            <img
              src={fgIdentitySolutions}
              style={{ width: '50px', height: '30px', marginLeft: '10px', borderRadius: '15px' }}
              alt="Logo"
            />
            <h4 style={{ fontFamily: 'sans-serif', marginLeft: '10px' }}>HRMS</h4>
          </div>
          <div className="auth-container">
            {isLoggedIn ? (
              <>
                <span className="username">{capitalizeFirstLetter(full_name)}</span>
                <button className="login-button" onClick={handleLogout}>
                  LOGOUT
                </button>
              </>
            ) : employeeUniqueId ? null : (
              <button className="login-button" onClick={handleLogin}>
                LOGIN
              </button>
            )}
          </div>
        </nav>
      </div>

      <div className={`part-2 ${isSidebarOpen ? "sidebar-open" : ""}`}>
        <div className="main-content">
          <Outlet />
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="fixed-1">Copyright&copy; 2025 | All Rights Reserved.</div>
          <div className="fixed-2">
            Designed and Developed by{" "}
            <a className="text-a" href="https://www.4gid.com/" target="_blank" rel="noopener noreferrer">
              4G Identity Solutions Pvt. Ltd.
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
